(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('LenderDeleteController',LenderDeleteController);

    LenderDeleteController.$inject = ['$uibModalInstance', 'entity', 'Lender'];

    function LenderDeleteController($uibModalInstance, entity, Lender) {
        var vm = this;

        vm.lender = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Lender.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
